import { render, staticRenderFns } from "./users-edit-page.vue?vue&type=template&id=eb0802be&scoped=true"
import script from "./users-edit-page.vue?vue&type=script&lang=js"
export * from "./users-edit-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0802be",
  null
  
)

export default component.exports